// The caller's country from the portal's 403 COUNTRY_NOT_SUPPORTED (`error[0].country`), kept for the
// geo_routed event on the "US only" card. Module memory only: a full reload starts without it.

let blockedCountry: string | undefined;

/** Remembers the country when the payload is a COUNTRY_NOT_SUPPORTED error that carries one. */
export function rememberBlockedCountry(payload: unknown): void {
  const first = (payload as { error?: Array<{ code?: unknown; country?: unknown }> } | null)?.error?.[0];
  if (first?.code !== "COUNTRY_NOT_SUPPORTED") return;
  if (typeof first.country === "string" && /^[A-Z]{2}$/.test(first.country)) blockedCountry = first.country;
}

export const getBlockedCountry = () => blockedCountry;
